import {createContext, useContext, useState} from "react";
import Order from "../rest/jtmc/models/Order";
import AppConfigContext from "./AppConfigContext";
import OrderAndOverviewData from "../rest/jtmc/models/OrderAndOverviewData";
import {OverviewData} from "../rest/jtmc/models/OverviewData";
import DiscountCodeResponse, {DiscountCodeApplyDetails} from "../rest/jtmc/models/DiscountCodeResponse";
import IPGLinkResponse from "../rest/jtmc/models/IPGLinkResponse";

export const OrderContext = createContext({} as OrderContextValues);

export type OrderContextValues = {
    selectPayment: (fetchKey: string) => void,
    selectDelivery: (fetchKey: string) => void,
    setDiscountCode: (code: string) => void,
    sendCtcReceipt: (receipt: File | undefined) => void,
    order: Order | null,
    overviewData: OverviewData | null,
    discountCodeDetails: DiscountCodeApplyDetails | null,
    setOrder: (o: Order) => void,
    cancel: () => void,
    ipgLink: () => Promise<string>
}

export function OrderProvider({children}: any) {
    const [order, setOrder] = useState<Order | null>(null);
    const [overviewData, setOverviewData] = useState<OverviewData | null>(null);
    const [discountCodeDetails, setDiscountCodeDetails] = useState<DiscountCodeApplyDetails | null>(null);

    const fetchContext = useContext(AppConfigContext).fetch;

    const paymentSelect = fetchContext.Order.requests.setPaymentMethod;
    const deliverySelect = fetchContext.Order.requests.setDeliveryMethod;
    const discountCodeSet = fetchContext.Order.requests.setDiscountCode;

    const setOrderModel = (o: Order|null) => {
        setOrder(o);
    }

    const selectPayment = (key: string) => {
        paymentSelect({method: key}).then((o: OrderAndOverviewData) => {
            setOrder(o.order);
            setOverviewData(o.overViewData);
        });
    }

    const selectDelivery = (key: string) => {
        deliverySelect({method: key}).then((o: OrderAndOverviewData) => {
            setOrder(o.order);
            setOverviewData(o.overViewData);
        });
    }

    const setDiscountCode = (code: string) => {
        discountCodeSet({code: code}).then((discountCodeResponse: DiscountCodeResponse) => {
            setOrder(discountCodeResponse.orderAndOverviewData.order);
            setOverviewData(discountCodeResponse.orderAndOverviewData.overViewData);
            setDiscountCodeDetails(discountCodeResponse.codeDetails);
        });
    }

    const sendCtcReceipt = (file: File | undefined) => {
        fetchContext.Order.requests.ctcPaymentConfirm(file).then((o: Order) => {
            setOrderModel(o);
        });
    }

    const ipgRequest = async () => {
        return fetchContext.Order.requests.getIPGLink().then((res: IPGLinkResponse) => {
            return res.url;
        });
    }

    const cancel = () => {
        fetchContext.Order.requests.cancel().then((o: Order) => {
            setOrderModel(null);
        });
    }

    return <OrderContext.Provider value={{
        setOrder: setOrderModel,
        setDiscountCode: setDiscountCode,
        selectPayment: selectPayment,
        selectDelivery: selectDelivery,
        sendCtcReceipt: sendCtcReceipt,
        cancel: cancel,
        ipgLink: ipgRequest,
        order: order,
        discountCodeDetails: discountCodeDetails,
        overviewData: overviewData
    }}>
        {children}
    </OrderContext.Provider>
}
